// components/index/service-category/aircon-service/AirconRequestSection.jsx
import { useState } from 'react'
import Image from 'next/image'
import { AnimatePresence } from 'framer-motion'
import { openModal } from 'service/modal-service'
import { AirconBooking } from './AirconBooking'
import { AirconItemSelection } from './AirconItemSelection'
import { Services } from '@/index/service/Services'
import { s3Static } from 'utils/constants'
import { BottomButtons } from './BottomButtons'

export default function AirconRequestSection({
  requestForm,
  setRequestForm,
  isQuickBook,
  setIsQuickBook,
  isCustomBook,
  setIsCustomBook,
  requestCategorySettings,
  standardServicing,
  chemicalServicing,
  overhaulServicing,
  currencyCd,
  countryName,
  requestType,
  setIsShowJobScope,
  serviceType,
  setServiceType,
  setUnit,
  setUnitType,
  setCost,
  heroImage,
  title,
  subtitle
}) {
  const [isShowAirconItemSelection, setIsShowAirconItemSelection] = useState(false)

  const showJobScope = (serviceType, unitType, unit, cost) => {
    setServiceType(serviceType)
    setUnit(unit)
    setUnitType(unitType)
    setCost(cost)
    openModal(setIsShowJobScope)
  }

  return (
    <>
        <section id="aircon-servicing-singapore" className='relative'>
            <div className="-mt-14 relative w-full aspect-21/9 sm:h-200 overflow-hidden">
                {/* Mobile Image - optimised LCP (replaces 1.6MB autoplay video) */}
                <Image
                    src={s3Static + "blog/living/aircon/repairman-doing-air-conditioner-service-1920-1080.jpg"}
                    fill
                    className="sm:hidden object-cover"
                    alt="StringsSG technician servicing a wall mounted aircon unit in Singapore"
                    priority
                    sizes="100vw"
                />

                {/* Desktop Image */}
                <Image
                    src={s3Static + heroImage}
                    fill
                    className="hidden sm:block object-cover"
                    alt={title}
                    priority
                    sizes="100vw"
                />

            </div> 
            <div id="campaign" className= " relative bg-gray-100 sm:bg-transparent sm:text-white w-full py-2 sm:absolute sm:top-1/2 sm:-translate-y-1/2">
                  <AirconBooking
                  requestCategorySettings={requestCategorySettings}
                  setRequestForm={setRequestForm}
                  oneTimeServicing={standardServicing}
                  chemicalServicing={chemicalServicing}
                  overhaulServicing={overhaulServicing}
                  setIsQuickBook={setIsQuickBook}
                  setIsCustomBook={setIsCustomBook}
                  currencyCd={currencyCd}
                  countryName={countryName}
                  showJobScope={showJobScope}
                  serviceType={serviceType}
                  setIsShowAirconItemSelection={setIsShowAirconItemSelection}
                  title={title}
                  subtitle={subtitle}
                  />
            </div>
        </section>
        {!requestForm &&
            <BottomButtons countryName={countryName}/>
        }
        {requestForm && 
            <Services
              requestType={requestType}
              requestCategorySettings={requestCategorySettings}
              setRequestForm={setRequestForm}
              isQuickBook={isQuickBook}
              isCustomBook={isCustomBook}
              asSheet
          />
        }
        {isShowAirconItemSelection && (
            <AnimatePresence>
            <AirconItemSelection
                setIsShowAirconItemSelection={setIsShowAirconItemSelection}
                setRequestForm={setRequestForm}
                setIsCustomBook={setIsCustomBook} setIsQuickBook={setIsQuickBook}
                userId={null}
            />
            </AnimatePresence>
        )}
    </>
  )
}